import type { ReactNode } from 'react';
import { adminUiCopy } from '../i18n/adminUi';
import { useI18n } from '../i18n/provider';
import { useAuth } from '../stores/auth';

export function SuperAdminRoute({ children }: { children: ReactNode }): JSX.Element {
  const { user } = useAuth();
  const { locale } = useI18n();
  const copy = adminUiCopy[locale].shared;

  if (!user?.isSuperAdmin) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <div className="text-red-700 font-semibold mb-1">{copy.accessDenied}</div>
          <div className="text-sm text-red-700 break-words">{copy.accessDeniedBody}</div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
